import React from 'react';
import { Form } from 'react-bootstrap';

const MonthsSelector = ({ selectedMonths, setSelectedMonths }) => {
  const handleMonthChange = (idx) => (e) => {
    const checked = e.target.checked;
    let newSelected = checked
      ? [...selectedMonths, idx + 1]
      : selectedMonths.filter((d) => d !== idx + 1);
    newSelected.sort((a, b) => a - b);
    setSelectedMonths(newSelected);
  };

  return (
    <Form.Group className="mb-3 w-100">
      <div className="d-flex flex-row mb-2 w-100 justify-content-between">
        <Form.Label className="fw-bold text-white mb-2"></Form.Label>
        <div className="d-flex flex-row">
          {['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'].map(
            (month, idx) => {
              const isChecked = selectedMonths.includes(idx + 1);
              return (
                <Form.Check
                  key={month}
                  type="checkbox"
                  id={`month-${month}`}
                  label={month}
                  className="text-white me-3"
                  checked={isChecked}
                  onChange={handleMonthChange(idx)}
                />
              );
            },
          )}
        </div>
      </div>
    </Form.Group>
  );
};

export default MonthsSelector;
